import { Permission } from './permissions.constants'
import { PAGE_PERMISSIONS_MAP, PAGE_REGEX_PERMISSIONS_MAP } from './pagePermissions.constants'

export const getPathPrefixRegex = (path: string): RegExp => {
  return new RegExp(`^${path}(/|[?]).*`)
}

export const getDirectRegexPathPermissions = (path: string): readonly Permission[] | null => {
  let result: readonly Permission[] | null = null
  let found = false
  const mapIterator = PAGE_REGEX_PERMISSIONS_MAP.entries()
  let next = mapIterator.next()
  while (!found && !next.done) {
    const [regex, permissions] = next.value
    if (regex.test(path)) {
      result = permissions
      found = true
    }
    next = mapIterator.next()
  }

  return result
}

export const getPathPrefixPermissions = (path: string): readonly Permission[] | null => {
  let result: readonly Permission[] | null = null
  let found = false
  const mapIterator = PAGE_PERMISSIONS_MAP.entries()
  let next = mapIterator.next()
  while (!found && !next.done) {
    const [page, permissions] = next.value
    if (getPathPrefixRegex(page).test(path)) {
      result = permissions
      found = true
    }
    next = mapIterator.next()
  }

  return result
}

export const getRequiredPermissionsForPage = (page: string): readonly Permission[] => {
  if (PAGE_PERMISSIONS_MAP.has(page)) {
    return PAGE_PERMISSIONS_MAP.get(page) || []
  }

  const directRegexPermissions = getDirectRegexPathPermissions(page)
  if (directRegexPermissions) {
    return directRegexPermissions
  }
  const prefixPermissions = getPathPrefixPermissions(page)
  if (prefixPermissions) {
    return prefixPermissions
  }

  return []
}
